import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

import { SkeletonLayout } from 'components/Skeleton/Skeleton';

import { CircularProgress } from './CircularLoader';

export const LoaderLayout = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth < 768;
      setIsMobile(newIsMobile);
    };

    const debouncedHandleResize = debounce(handleResize, 150);
    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      debouncedHandleResize.cancel();
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [setIsMobile]);

  return isMobile ? <SkeletonLayout /> : <CircularProgress />;
};
